import React from "react";
import { useSelector } from "react-redux";
import { useDeviceSize, MOBILE } from "../assets/hooks/useDeviceSize";

export default function PoweredBy({ branded }) {

	const color = useSelector(state => state.vendor ? state.vendor.featureColor1 : null);
	const { device } = useDeviceSize();

	return <span
		className="powered-by"
		style={branded
			?
			{
				backgroundColor: device === MOBILE ? "#1f1f1f" : "transparent",
				color: device === MOBILE ? "rgb(228, 228, 228)" : "#000000"
			} : {
				backgroundColor: "transparent",
				color: "#000000"
			}
		}
	>
		<span>Powered by</span> <a href="https://orderabl.com" target="_blank" rel="noopener noreferrer" className="featureFont">ORDERABL<span className="brand-c" style={{
			...(color && branded ? { color } : {})
		}}>+</span></a>
	</span>
}
